import React from 'react';
import { Chip } from '@mui/material';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import TrendingFlatIcon from '@mui/icons-material/TrendingFlat';

/**
 * Chip mostrando variação % vs período anterior.
 * - delta_pct > 0 → verde (subiu)
 * - delta_pct < 0 → vermelho (caiu)
 * - delta_pct === 0 → cinza (estável)
 *
 * Para algumas métricas (ex.: auth fail), subir é ruim — passe `inverted=true`
 * pra inverter a cor.
 */
export default function DeltaChip({ value = 0, inverted = false, label = "vs período anterior" }) {
    const v = Number(value) || 0;
    const isUp = v > 0;
    const isDown = v < 0;
    const isFlat = v === 0;

    let color = 'default';
    let icon = <TrendingFlatIcon fontSize="small" />;
    if (isUp) {
        color = inverted ? 'error' : 'success';
        icon = <TrendingUpIcon fontSize="small" />;
    } else if (isDown) {
        color = inverted ? 'success' : 'error';
        icon = <TrendingDownIcon fontSize="small" />;
    }

    const sign = isUp ? '+' : '';
    return (
        <Chip
            size="small"
            icon={icon}
            color={color}
            variant="outlined"
            label={isFlat ? `${label}: estável` : `${sign}${v.toFixed(1)}% ${label}`}
        />
    );
}
